// extracted by mini-css-extract-plugin
export default {"wrapper":"pages_wrapper__QF3n6","page":"pages_page__s0e2r","error":"pages_error__Vedb8"};